import ApplicationsFilters from './ApplicationsFilters.component';

export default ApplicationsFilters;
